<template>
  <stat :title="$t('dashboard.offertyperepartition.title')" :loading="loading">
    <offer-type-repartition-chart
      :dataKey="dataKey"
      :height="200"
      :params="params"
      style="width: 100%"
      lazy></offer-type-repartition-chart>
  </stat>
</template>

<script>
  import { OfferTypeRepartitionChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      OfferTypeRepartitionChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'offersRevenue'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/OfferTypeRepartition.vue